<template>
  <yxt-drawer
    class="eval_addreport_drawer addreportDrawer"
    size="660px"
    :visible.sync="visibleDrawer"
    destroy-on-close
    :before-close="beforeDrawClose"
    @close="close"
  >
    <div slot="title">
      <div class="addHeader-box">
          {{$t('pc_gwnl_eval_import_eval_title')}}
      </div>
    </div>
    <div>
    <TeamReportNameSet
      ref="teamReportNameSet"
      :models="models"
      :import-methods="importMethods"
      @success="handleImportSuccess"
    />
    </div>
    <div slot="footer">
      <yxt-button plain @click="handleCancel">
        {{ $t('pc_gwnl_global_msg_cancel') }}
      </yxt-button>
      <!-- <yxt-button type="primary" @click="nextStep">
        {{ $t('pc_gwnl_web_homework_btn_done') }}
      </yxt-button> -->
    </div>
  </yxt-drawer>
</template>
<script>
import TeamReportNameSet from './components/importData';
import { reportsProjectPeopleImprot, getModelNameByIds } from './service.js';
export default {
  name: 'YxtbizEvalImportEvalCreate',
  name_zh: '导入测评抽屉',
  components: {
    TeamReportNameSet
  },
  eventList: [{
    type: 'success',
    handler: 'handleImportSuccess',
    label: '导入人员成功后的回调'
  }],
  props: {
    evalType: { // 测训项目需要区分前后测。测评类型 1:前测测评，2:后测测评 ,3:不区分前后测
      type: Number,
      desc: '测训项目需要区分前后测的测评类型',
      setter: 'TabSetter',
      enums: [{
        label: '前测测评',
        value: 1
      }, {
        label: '后测测评',
        value: 2
      }, {
        label: '不区分前后测',
        value: 3
      }]
    },
    modelIds: {
      type: Array,
      default: [],
      desc: '传入模型ID,支持多个或一个数组',
      setter: 'JsonSetter'
    },
    visible: {
      type: Boolean,
      default: false,
      desc: '组件的显隐',
      setter: 'BooleanSetter'
    },
    source: { // (value = "来源类型（0-单独安排；1-测训项目安排；2-人才盘点安排, 3-代运营, 4-岗位地图安排，5-层级地图 6-第三方导入，7-档案)")
      type: Number,
      required: true,
      desc: '来源类型',
      setter: 'SelectSetter',
      enums: [{
        label: '单独安排',
        value: 0
      }, {
        label: '测训项目安排',
        value: 1
      }, {
        label: '人才盘点安排',
        value: 2
      }, {
        label: '代运营安排',
        value: 3
      }, {
        label: '岗位地图安排',
        value: 4
      }, {
        label: '层级地图安排',
        value: 5
      }, {
        label: '第三方导入',
        value: 6
      }, {
        label: '档案',
        value: 7
      }]
    },
    projectId: {
      type: String,
      default: '',
      desc: '业务线，项目id, 组件会透传，测评导入成功会回调',
      setter: 'StringSetter'
    }
  },
  watch: {
    visible: {
      immediate: true,
      handler(val) {
        if (val) {
          if (!this.validProps()) {
            this.$emit('update:visible', false);
            return;
          }
        }
        this.visibleDrawer = val;
      }
    },
    visibleDrawer(val) {
      this.$emit('update:visible', val);
    },
    modelIds: {
      immediate: true,
      handler(val) {
        this.getModelNameByIds(val);
      }
    }
  },
  data() {
    return {
      models: [],
      functionCode: '',
      dataPermissionCode: '',
      visibleDrawer: false,
      loading: true
    };
  },
  computed: {},
  created() {},
  mounted() {
    // this.tableHeight = this.$refs[this.refTable].$el.clientHeight
  },
  methods: {
    getModelNameByIds(ids) {
      console.log(ids, 'ids......');
      if (!ids || !ids.length) return;
      getModelNameByIds(ids)
        .then((res) => {
          console.log(JSON.stringify(res), 'then......');
          if (res && res.length) {
            this.models = res.map((item, index) => {
              return {
                id: item.id,
                name: item.name || index
              };
            });
          }
        }).catch((e) => {
          console.log(e);
        });
    },
    validProps() {
      if (!this.source) {
        this.$message.warning('source 不能为空');
        return;
      }

      if (this.source !== 6 && !this.projectId) {
        this.$message.warning('project 不能为空');
        return;
      }

      if (this.source === 1 && !this.evalType) {
        this.$message.warning('evalType 不能为空');
        return;
      }
      console.log(this.modelIds, 'xxxxx');

      if (!this.modelIds.length) {
        this.$message.warning('modelIds 不能为空');
        return;
      }

      if (this.modelIds.length > 5) {
        this.$message({
          showClose: false,
          message: this.$t('pc_gwnl_eval_selectDepartmentMaxTips', { cunt: 5 }),
          type: 'error'
        });
        return;
      }
      return true;
    },
    handleImportSuccess(e) {
      // this.$message.success(this.$t('pc_gwnl_global_msg_operationSuccessful'))
      console.log(e);
      this.$emit('success');
      this.closeLayer();
    },
    handleCancel() {
      this.closeLayer();
    },
    importMethods(file) {
      let formdata = new FormData();
      if (this.$isV1) {
        formdata.append('file', file);
      } else {
        formdata.append('fileId', file.id);
      }
      let list = this.modelIds || [];
      let data = {
        // fileUrl: formdata,
        modelIdList: list.join(',') || '',
        source: this.source,
        evalType: this.evalType,
        projectId: this.projectId
      };
      return reportsProjectPeopleImprot(data, formdata);
    },
    newModel() {
      // protocol: window.location.protocol || 'https:',
      // host: window.location.host,
      // path: this.$isV1 ? '/talent/' : '/gwnl/',
      console.log(`${this.host}${this.path}#/model/template/info`);
      window.open(
        `${this.protocol}//${this.host}${this.path}#/model/template/info`
      );
    },
    closeLayer() {
      this.visibleDrawer = false;
    },
    close() {
      // this.$emit('update:modelIds', [])
    },
    beforeDrawClose(done) {
      done();
    }
  }
};
</script>
<style lang="scss">
.eval_addreport_drawer {
  &.addreportDrawer {
    .more_position {
      width: calc(100% - 236px) !important;
    }
  }

  .pt12 {
    padding-top: 12px;
  }

  .addHeader-box {
    display: flex;

    .setp-item {
      display: flex;
      flex-grow: 1;
      align-items: center;
      justify-content: flex-start;
      padding: 0 12px;

      &.unset {
        .step-text {
          color: #595959;
        }

        .gwnl-eval-step__index {
          color: #8c8c8c;
          font-weight: 400;
          background: #f0f0f0;
        }
      }

      &.setp-item1 {
        justify-content: flex-end;
      }

      .step-text {
        margin-left: 8px;
        color: #436bff;
        font-weight: 400;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        line-height: 22px;
      }

      .gwnl-eval-step__index {
        display: inline-block;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 16px;
        height: 16px;
        color: #fff;
        font-weight: 400;
        font-size: 10px;
        font-family: DINPro-Bold, DINPro;
        line-height: 12px;
        background: #436bff;
        border-radius: 50%;
      }
    }
  }

  .search-text-span {
    margin-bottom: 12px;
    color: #595959;
    font-weight: 400;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    line-height: 22px;

    .report-num-span {
      color: #f5222d;
      font-weight: bold;
    }
  }

  .yxt-drawer__body {
    padding: 0;
  }

  .eval-check-person-range {
    position: relative;
    display: flex;
    flex-direction: column;
    height: 100%;
    padding: 24px;
  }

  .table_wrapper_search {
    display: flex;
    justify-content: space-between;

    .search-input {
      width: 240px;
    }

    .newModel {
      position: relative;
      color: #436bff;
      font-size: 14px;
      line-height: 48px;
      cursor: pointer;

      .newModel-tips {
        position: absolute;
        top: -12px;
        left: 50%;
        z-index: 10;
        display: none;
        width: 164px;
        height: 22px;
        color: #fff;
        font-size: 12px;
        line-height: 22px;
        text-align: center;
        background: #f5a623;
        border-radius: 2px;
        transform: translate(-50%, 0);

        &::before {
          position: absolute;
          bottom: -3px;
          left: 50%;
          display: block;
          width: 0;
          height: 0;
          border-color: #f5a623 transparent transparent transparent;
          border-style: solid;
          border-width: 4px 4px 0 4px;
          transform: translate(-50%, 0);
          content: '';
        }
      }
    }

    &:hover {
      .newModel-tips {
        display: block;
      }
    }
  }

  .more_position {
    display: flex;
    width: calc(100% - 236px);
    height: 100%;
    padding: 0 24px 0 0 !important;

    .tree-scroll-wrap {
      flex: 1;
      width: 100% !important;
      height: 100%;

      > .yxt-scrollbar {
        height: 100%;
      }
    }

    .yxtbiz-dept-tree,
    .yxtbiz-pos-tree {
      display: flex;
      flex-direction: column;
      height: 100%;
    }

    .table_tree {
      // width: 260px;
      overflow: hidden;
      // margin-right: 24px;
      // height: 100%;
      .yxtbiz-user-group-tree {
        display: flex;
        flex-direction: column;
        height: 100%;
      }
    }

    .table_wrapper {
      display: flex;
      flex: 1;
      // padding-top: 10px;
      flex-direction: column;
      width: 604px;
      // overflow: hidden;
    }

    .person-table {
      flex: 1;
      overflow: hidden;
    }

    .keyword {
      width: 200px;
      margin-bottom: 16px;
    }

    .yxtbiz-page__content {
      display: flex;
      justify-content: space-between;
      margin-top: 16px;
      //margin-bottom: 27px;
      .yxtbiz-page__content-right {
        display: flex;
      }

      .disabled {
        cursor: not-allowed;
      }

      .yxtbiz-loading__all,
      .circular {
        width: 16px;
        height: 16px;

        .yxt-loading-spinner {
          margin-top: 0;
        }
      }
    }
  }

  .list__wrapper {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    width: 260px;
    border-left: 1px solid #e9e9e9;
  }

  .checked_list {
    position: relative;
    height: 100%;

    .operation {
      position: absolute;
      bottom: 24px;
      left: 25px;
      display: flex;
      justify-content: space-between;

      span:nth-child(2) {
        color: #436bff;
        cursor: pointer;
      }
    }

    .check-list__placeholder {
      position: absolute;
      top: 24px;
      left: 20px;
      color: #bfbfbf;
      font-size: 14px;
    }

    .checked_list_box {
      box-sizing: border-box;
      height: calc(100% - 48px);
      padding: 8px;
      padding-top: 24px;
      padding-left: 21px;
      overflow-x: auto;
      border-radius: 4px;

      .tag {
        margin-right: 8px;
        margin-bottom: 10px;
      }

      .tag_span {
        max-width: 160px;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
}
</style>
<style lang="scss" scoped>
/deep/ .has-gutter {
  .yxt-checkbox__inner {
    display: none;
  }
}

.pages-box {
  text-align: right;
}
</style>
